import axios from 'axios';
import { parseApiError } from '@/helpers/api-requests';

const actions = {
  async createUnit(store, unit) {
    const { dispatch, state } = store;
    return await axios({
      url: `/v1/packages/${state.pkg.id}/units`,
      method: 'POST',
      data: { units: [unit] },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getPackage');
        return Promise.resolve(unit);
      })
      .catch(parseApiError);
  },
  async updateUnit(store, unit) {
    const { dispatch, state } = store;
    return await axios({
      url: `/v1/packages/${state.pkg.id}/units/${unit.id}`,
      method: 'PUT',
      data: { ...unit },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getPackage');
        return Promise.resolve(unit);
      })
      .catch(parseApiError);
  },
  async deleteUnit(store, unitID) {
    const { dispatch, state } = store;
    return await axios({
      url: `/v1/packages/${state.pkg.id}/units/${unitID}`,
      method: 'DELETE',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getPackage');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
};

export default actions;